//LoginPage.jsx

import React,{useState} from "react";
import {Link,useNavigate} from "react-router-dom";
import {login} from "../api/reportApi";

export default function LoginPage(){
    const navigate=useNavigate();
    const [email,setEmail]=useState("");
    const [password,setPassword]=useState("");
    const [error,setError]=useState("");
    const [loading,setLoading]=useState(false);

    const handleSubmit=async e=>{
        e.preventDefault();
        if(loading)return;
        setError("");
        try{
            setLoading(true);
            await login(email.trim(),password);
            navigate("/app",{replace:true});
        }catch(err){
            setError(err.message||"Login failed");
        }finally{
            setLoading(false);
        }
    };

    return(
        <div className="min-h-screen flex items-center justify-center bg-black text-white px-4">
            <form onSubmit={handleSubmit} className="w-full max-w-md rounded-2xl border border-gray-700 bg-neutral-950 p-6 shadow-xl">
                <h1 className="text-2xl font-semibold mb-6">Login to Custor</h1>
                <div className="space-y-4">
                    <input type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} disabled={loading} autoComplete="email" className="w-full rounded-xl border border-gray-700 bg-black px-4 py-3 text-white"/>
                    <input type="password" placeholder="Password" value={password} onChange={e=>setPassword(e.target.value)} disabled={loading} autoComplete="current-password" className="w-full rounded-xl border border-gray-700 bg-black px-4 py-3 text-white"/>
                    {error&&<div className="text-sm text-red-400">{error}</div>}
                    <button type="submit" disabled={loading||!email.trim()||!password} className="w-full rounded-xl bg-red-500 py-3 font-semibold text-black disabled:opacity-50">
                        {loading?"Signing in...":"Login"}
                    </button>
                </div>
                <div className="mt-5 text-sm text-gray-400">
                    Don't have an account?{" "}
                    <Link to="/register" className="text-red-400 hover:text-red-300">Register</Link>
                </div>
                <div className="mt-10 text-sm text-gray-500">
                    <Link to="/terms" className="hover:text-gray-300">Terms of Service</Link>{" · "}
                    <Link to="/privacy" className="hover:text-gray-300">Privacy Policy</Link>{" · "}
                    <Link to="/refund" className="hover:text-gray-300">Refund Policy</Link>
                </div>
            </form>
        </div>
    );
}